import { actionTypes } from '../actions/types';

export default function route(state = {}, action) {
  switch (action.type) {
    case actionTypes.SET_REDIRECT_PATH:
      return {
        ...state,
        redirectPath: action.redirectPath,
        errorType: action.errorType,
      };
    default:
      return state;
  }
}
